import React from 'react';
import FolderItem from './components/folder-item/folder-item.tsx';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useMediaLibraryStore from '@store/media-library-store/media-library.store.ts';
import { FolderModel } from '@models/media-library.model.ts';

const Folders: React.FC<{ onEditClick: (folder: FolderModel) => void }> = ({
  onEditClick
}) => {
  const { t } = useTranslation();
  const {
    foldersData,
    checkedItems,
    checkedMediaItems,
    toggleItemChecked,
    toggleSelectAll,
    setCurrentFolder,
    resetSearch
  } = useMediaLibraryStore();

  const disableFolders = Object.values(checkedMediaItems).some(Boolean);

  const allChecked =
    Object.keys(checkedItems).length > 0 &&
    Object.values(checkedItems).every(Boolean);
  const someChecked = Object.values(checkedItems).some(Boolean) && !allChecked;

  const handleSelectAllChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    toggleSelectAll(event.target.checked);
  };

  const handleFolderClick = (folder: FolderModel) => {
    resetSearch();
    setCurrentFolder(folder);
  };

  const handleEditClick = (folder: FolderModel) => {
    onEditClick(folder);
  };

  return (
    <div>
      <FormControlLabel
        disabled={disableFolders}
        className="ml-0!"
        control={
          <Checkbox
            className="primary-checkbox"
            checked={allChecked}
            indeterminate={someChecked}
            onChange={handleSelectAllChange}
            disabled={disableFolders}
          />
        }
        label={
          <span className="text-(--blue-4) text-base ml-1">
            {t('view_controls_select_all')}
          </span>
        }
      />

      <div className="flex items-center gap-4 mt-4 overflow-x-auto max-lg-xl:mt-1.5">
        {foldersData.map((folder: any) => (
          <FolderItem
            key={folder.id}
            data={folder}
            checked={checkedItems[folder.id] || false}
            disabled={disableFolders}
            onCheckedChange={(checked: boolean) =>
              toggleItemChecked(folder.id, checked)
            }
            onFolderClick={handleFolderClick}
            onEditClick={handleEditClick}
          />
        ))}
      </div>
    </div>
  );
};

export default Folders;
